import React, { useEffect, useState } from 'react';
import { post_data } from '../../../api';
import toast from 'react-hot-toast';
import { Backdrop, CircularProgress } from '@mui/material';
import { Result, Button } from 'antd';
import { SmileOutlined, FrownOutlined } from '@ant-design/icons';

const PaymentResponse = () => {
    const [status, setStatus] = useState('LOADING');

    const checkStatus = async (merchantOrderId) => {
        try {
            const formData = JSON.parse(localStorage.getItem('speedGoverner'));

            const result = await post_data('speed-governor/verify-payment', { ...formData, merchantOrderId });

            if (result?.status === true) {
                toast.success("Payment Successful");
                setStatus('SUCCESS');
            } else {
                toast.error("Payment Failed");
                setStatus('FAILED');
            }
        } catch (e) {
            console.log('error', e);
            toast.error("An error occurred while verifying payment");
            setStatus('FAILED');
        } finally {
            localStorage.removeItem('speedGoverner');
        }
    }

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const merchantOrderId = query.get('merchantOrderId');

        checkStatus(merchantOrderId);
    }, []);

    if (status === 'LOADING') {
        return (
            <Backdrop
                sx={{
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px'
                }}
                open={true}
            >
                <CircularProgress color="inherit" />
                <div style={{ fontSize: '1.2rem' }}>Verifying your payment...</div>
            </Backdrop>
        );
    }

    if (status === 'SUCCESS') {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f0f2f5',
                padding: '20px'
            }}>
                <Result
                    icon={<SmileOutlined style={{ color: '#52c41a' }} />}
                    status="success"
                    title="Payment Successful!"
                    subTitle="Your payment has been confirmed. Thank you for your purchase."
                    extra={[
                        <Button 
                            type="primary" 
                            key="console" 
                            href="/"
                            style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }}
                        >
                            Go to Home
                        </Button>,
                        <Button 
                            key="buy" 
                            href="/company/dashboard/speedgoverner"
                            style={{ marginLeft: '10px' }}
                        >
                            Back to Dashboard
                        </Button>,
                    ]}
                    style={{
                        backgroundColor: 'white',
                        padding: '40px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        maxWidth: '800px',
                        width: '100%'
                    }}
                />
            </div>
        );
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#f0f2f5',
            padding: '20px'
        }}>
            <Result
                icon={<FrownOutlined style={{ color: '#ff4d4f' }} />}
                status="error"
                title="Payment Failed"
                subTitle="Please check your payment details and try again."
                extra={[
                    <Button 
                        type="primary" 
                        key="retry" 
                        href="/company/dashboard/speedgoverner"
                        style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
                    >
                        Try Again
                    </Button>,
                    <Button 
                        key="contact" 
                        href="/contact"
                        style={{ marginLeft: '10px' }}
                    >
                        Contact Support
                    </Button>,
                ]}
                style={{
                    backgroundColor: 'white',
                    padding: '40px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    maxWidth: '800px',
                    width: '100%'
                }}
            />
        </div>
    );
};

export default PaymentResponse;